import * as DateHandler from 'utils/DateHandler';
import LocaleUtil from 'utils/LocaleUtil';

/** The locale strings that the access status ladder needs. */
export interface ShareAccessStatusLocale {
  cloudShare: {
    infoViewsAt: string;
    infoViewsOn: string;
    notNotified: string;
    notifiedAt: string;
    notifiedOn: string;
    viewedAt: string;
    viewedOn: string;
  };
}

/** The part of a share that the access status ladder reads. */
export interface ShareAccessStatusShare {
  notified?: number;
  views?: number[];
}

/**
 * Build the access status sentence for one share recipient.
 * The ladder reports many views, then a single view, then the notification,
 * then "not yet notified".
 * The Legacy save panel and the Aspen save panel both call this function.
 */
export function getShareAccessStatusText(
  share: ShareAccessStatusShare,
  locale: ShareAccessStatusLocale,
): string {
  const accesses = share.views || [];

  let accessStatusTooltip = `${locale.cloudShare.notNotified}`;
  if (accesses.length > 0) {
    const { time: accessTime, date: accessDate } = DateHandler.toCompactString(
      accesses[accesses.length - 1],
    );

    if (accesses.length > 1) {
      accessStatusTooltip = !accessTime
        ? LocaleUtil.getLocalizedStr({
            string: locale.cloudShare.infoViewsOn,
            replacements: { count: accesses.length, date: accessDate },
          })
        : LocaleUtil.getLocalizedStr({
            string: locale.cloudShare.infoViewsAt,
            replacements: { count: accesses.length, time: accessTime },
          });
    } else {
      accessStatusTooltip = !accessTime
        ? LocaleUtil.getLocalizedStr({
            string: locale.cloudShare.viewedOn,
            replacements: { date: accessDate },
          })
        : LocaleUtil.getLocalizedStr({
            string: locale.cloudShare.viewedAt,
            replacements: { time: accessTime },
          });
    }
  } else if (share.notified) {
    const { time: notifiedTime, date: notifiedDate } = DateHandler.toCompactString(share.notified);
    accessStatusTooltip = !notifiedTime
      ? LocaleUtil.getLocalizedStr({
          string: locale.cloudShare.notifiedOn,
          replacements: { date: notifiedDate },
        })
      : LocaleUtil.getLocalizedStr({
          string: locale.cloudShare.notifiedAt,
          replacements: { time: notifiedTime },
        });
  }

  return accessStatusTooltip;
}
